import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FormStatus, FormVisibility } from '../../models/Form';
export function convertTemplateFormToUnsavedForm(templateForm) {
  var convertedForm = _objectSpread(_objectSpread({
    id: undefined,
    updated: templateForm.updated,
    design: templateForm.design
  }, templateForm.publish && {
    publish: templateForm.publish
  }), {}, {
    state: createStateFromTemplateForm(templateForm)
  });
  return convertedForm;
}
function createStateFromTemplateForm(templateForm) {
  return {
    visibility: FormVisibility.Internal,
    status: FormStatus.Open,
    answers: populateDefaultAnswers(templateForm.design.questions)
  };
}
function populateDefaultAnswers(questions) {
  var formAnswers = {};
  Object.keys(questions).forEach(function (key) {
    var question = questions[key];
    if (question.defaultAnswer) {
      formAnswers[key] = question.defaultAnswer;
    }
  });
  return formAnswers;
}